module.exports = __webpack_public_path__ + "img/ledger.1a5ee423.png";